export enum CoverageCheckoutButtonsFeeProductBehavior {
  RemoveUntilCheckout = "remove_until_checkout",
  IgnoreUntilCheckout = "ignore_until_checkout",
}
